import { useCallback } from "react";

import { usePreferenceValue } from "@/hooks/use-preference-value";

const DISMISS_KEY_PREFIX = "CONVERT_TO_PROJECT_DISMISSED";

export function getDismissPreferenceKey(environmentId: string): string {
    return `${DISMISS_KEY_PREFIX}:${environmentId}`;
}

export const useConvertToProjectDismissed = (environmentId: string) => {
    const preferenceKey = getDismissPreferenceKey(environmentId);
    const { value, setValue, deleteValue, isLoading } = usePreferenceValue(preferenceKey);

    const dismiss = useCallback(() => {
        setValue(new Date().toISOString());
    }, [setValue]);

    return {
        isDismissed: !!value,
        isLoading,
        dismiss,
        clearDismissal: deleteValue,
    };
};
